import React from 'react';

const TravelHistoryView = React.lazy(() => import('./TravelHistoryView'));

const TravelHistoryScreen = (props: any) => {
  return (
    <React.Suspense>
      <TravelHistoryView {...props} />
    </React.Suspense>
  );
};

export default TravelHistoryScreen;
